import {
  GDSInputStatus,
  GDSStyleObject,
  keyframes,
} from '@leagueplatform/genesis-core';
import type { GDSIconProps } from '@leagueplatform/genesis-core';
import type { ReportStatus } from '@web-config-app/core-react';

export const inputStatusIconLabelMap: Record<GDSInputStatus, string> = {
  error: 'ERROR',
  warning: 'WARNING',
  success: 'SUCCESS',
};

export type NonLoadingStatus = Exclude<ReportStatus, 'loading'>;

export const statusIconMap: Record<
  NonLoadingStatus,
  {
    icon?: GDSIconProps['icon'];
    tint?: GDSIconProps['tint'];
  }
> = {
  success: {
    icon: 'tinyValidationCheck',
    tint: '$successIcon',
  },
  skipped: {
    icon: 'statusInformationCircle2Filled',
    tint: '$highlightIcon',
  },
  error: {
    icon: 'tinyClear',
    tint: '$criticalIcon',
  },
  // unprocessed does not render an icon
  unprocessed: {},
};

export const TOP_BAR_LINEAR_GRADIENT =
  'linear-gradient(to bottom, #FFFFFFCC, transparent)';

const slideInFromTop = keyframes({
  '0%': { opacity: 0, transform: 'translateY(-100%)' },
  '100%': { opacity: 1, transform: 'translateY(0)' },
});

export const bannerAnimation = `${slideInFromTop} $transitions$defaultTime ease-in`;

export const richTextElementsCss: GDSStyleObject = {
  typography: '$bodyTwo',
  h1: {
    typography: '$headingOne',
    margin: '$one 0',
  },
  h2: {
    typography: '$headingTwo',
    margin: '$one 0',
  },
  h3: {
    typography: '$headingThree',
    margin: '$one 0',
  },
  h4: {
    typography: '$headingFour',
    margin: '$one 0',
  },
  h5: {
    typography: '$subtitleOne',
    margin: '$one 0',
  },
  h6: {
    typography: '$subtitleTwo',
    margin: '$one 0',
  },
  b: {
    fontWeight: '$subtitleOne',
  },
  i: {
    fontStyle: 'italic',
  },
  em: {
    fontStyle: 'italic',
  },
  a: {
    color: '$interactiveActionPrimary',
  },
  ol: {
    listStyle: 'revert',
    paddingInlineStart: '$one',
    margin: '$one 0',
  },
  ul: {
    listStyle: 'revert',
    paddingInlineStart: '$one',
    margin: '$one 0',
  },
  blockquote: {
    margin: '$one',
    display: 'flex',
    '&::before': {
      flexShrink: 0,
      marginInlineEnd: '$one',
      content: '',
      width: '5px',
      borderRadius: '$large',
      backgroundColor: '$decorativeBrandPrimaryBrightest',
    },
  },
};
